module.exports = {
          srcSet: __webpack_public_path__ + "/assets/8cc09ec139a07d430b0c09d5fd7dbddc-320.jpg"+" 320w"+","+__webpack_public_path__ + "/assets/987fdf2c7af4260be128da24aea34f61-400.jpg"+" 400w",
          images:[ {path: __webpack_public_path__ + "/assets/8cc09ec139a07d430b0c09d5fd7dbddc-320.jpg",width: 320,height: 320},{path: __webpack_public_path__ + "/assets/987fdf2c7af4260be128da24aea34f61-400.jpg",width: 400,height: 400}],
          src: __webpack_public_path__ + "/assets/8cc09ec139a07d430b0c09d5fd7dbddc-320.jpg",
          toString:function(){return __webpack_public_path__ + "/assets/8cc09ec139a07d430b0c09d5fd7dbddc-320.jpg"},
          
          width: 320,
          height: 320
        }